import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Nav, { NavItem } from 'tbk-components/src/components/Nav';
import Tabs from 'tbk-components/src/components/Tabs';
import Tab from 'tbk-components/src/components/Tab';

export interface IFooterNavItemProps extends IBaseElementProps {
	item?: NavItem;
}

const FooterNavItem: React.FC<IFooterNavItemProps> = ({
	item,
}) => {
	if (!item) {
		return null;
	}

	let classNames = item.classNames ? item.classNames : [];
	if (item.children) {
		let children = item.children as NavItem[];

		if ( classNames.indexOf('tab') !== -1 ) {
			return (
				<div
					className={cn(
						'calian-footer__column--tab-container',
						classNames,
					)}
				>
					<h6 className="calian-footer__column--tab-heading">
						{item.label}
					</h6>
					<Tabs>
						{children.map((child, index) => {
							if (child.children instanceof Array) {
								let tabNavItems =
									child.children as NavItem[];
								return (
									<Tab key={index} title={child.label}>
										<Nav
											navItems={tabNavItems}
											collapseEnabled={false}
											dropdownEnabled
											classNames={[
												'calian-footer__column--tab-nav',
											]}
										/>
									</Tab>
								);
							} else {
								return (
									<Tab key={index} title={child.label}>
										<div
											dangerouslySetInnerHTML={{
												__html: child.children as string,
											}}
										/>
									</Tab>
								);
							}
						})}
					</Tabs>
				</div>
			);
		} else {
			let currentNav = [item];
			return (
				<Nav
					navItems={currentNav}
					collapseEnabled
					dropdownEnabled={false}
					classNames={[
						'calian-footer__nav-dropdown',
						...classNames,
					]}
				/>
			);
		}
	} else {
		return (
			<a
				className={cn('calian-footer__nav-link', classNames)}
				href={item.href}
				target={item.target}
			>
				{item.label}
			</a>
		);
	}
};

export default FooterNavItem;
